import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback,WarningCallback,QuestionCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { 
  listsCallInTypeUpdate, 
  listsCallInTypeSub1Update,  
  listsCustomerSurveyUpdate
 } from "store/actions"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import FormLabel from "@material-ui/core/FormLabel"
import CallIcon from '@material-ui/icons/Call';
import CallEndIcon from '@material-ui/icons/CallEnd';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'; 
import * as Alert from "alertService"

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'; 
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate" 

// @material-ui/icons 
import ContactPhoneIcon from '@material-ui/icons/ContactPhone'; 
import PhoneIcon from '@material-ui/icons/Phone';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'; 
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select" 
import TextField from '@material-ui/core/TextField';
import Iframe from 'react-iframe'
// import Switch from "@material-ui/core/Switch";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
var W3CWebSocket = require('websocket').w3cwebsocket;
var client = null; 

const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  }
}
const userData = Auth.getUserData()
const user_login_fullname = (userData)?userData.firstname + " " + userData.lastname : ""
function TabContainer(props) { 
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      QAgantAllready:false,
      buttonSaveCall:false, 
      isOpenQuestion:false,
      pageName:"การโทรเข้า-หมวดหมู่",
      statusFixedQCNotPass:false,
      _id:null,
      code: "",
      description: "",
      rowCurrentData:{},
      tabsIndex:0,
      isCalling:false,
      callInTypeListRaw: [],
      callInTypeList: [],
      callInTypeCurrentID: "",
      callInType1List: [],
      callInType1ListRaw: [],
      callInType1CurrentID: "",
      cerrentNote:"",
      rawListDataStatus:[],
      cerrentQCNote:"",

      expansionPanelIsOpen1:true,
      expansionPanelIsOpen2:true,
    }
  }

  componentDidMount() { 
    this.props.listsCallInTypeUpdate(false)
    this.onConnectingQAgent() 
  }
  onConnectingQAgent() {
    client = new W3CWebSocket('ws://127.0.0.1:8748/QAgent'); 
    client.onerror = (e)=> {
      console.log('Connection Error');
      this.setState({QAgantAllready:false})
    }; 
    client.onopen = ()=> {
        console.log('WebSocket Client Connected'); 
        this.setState({QAgantAllready:true})
    };
    client.onclose = ()=> {
      console.log('Client Closed. Waiting 2 sec for reconnecting.');
      setTimeout(()=>{
          console.log('Client reconnecting...'); 
          this.onConnectingQAgent()
      },2000); 
    };
    client.onmessage = (e)=> {   
      if (typeof e.data === 'string') {
        const res = JSON.parse(e.data); 
        console.log("Received message : '" + res.message + "'"); 
      }
    };
  }
  onDownloadListStatus() { 
    const dataToSend = {
      lead_id: this.state._id, 
    } 
    APIPost( UrlServer.URL_POST_POST_TELESURVEYHISTORY_GETCALLHISTORY,dataToSend,(datas)=>{  
         this.setState({rawListDataStatus:datas.datas})
    })
  }
  componentWillUpdate(nextProps, nextState) {
      if(nextProps.currentData && nextProps.currentData !== nextState.rowCurrentData){
        this.setState({
          rowCurrentData: nextProps.currentData,
          cerrentQCNote:nextProps.currentData.qc_note,
          _id:nextProps.currentData._id,
          code: nextProps.currentData.code,
          description: nextProps.currentData.description,
          statusFixedQCNotPass:false
        },()=>{
          this.onDownloadListStatus(nextProps.currentData._id)
        })
      } 

      if (nextProps.listsCallInType !== nextState.callInTypeListRaw) {
        const newConvertDatas = arrayObject(nextProps.listsCallInType, [
          {
            oldKey: "_id",
            newKey: "value"
          },
          {
            oldKey: "description",
            newKey: "name"
          }
        ])
        if(newConvertDatas.length < 1)return
        this.setState({
          statusWaitingUpdate: false,
          callInTypeList: newConvertDatas,
          callInTypeListRaw: nextProps.listsCallInType, 
        }, () => {

        })
      }

      if (nextProps.listsCallInTypeSub1 !== nextState.callInType1ListRaw) {
        const newConvertDatas = arrayObject(nextProps.listsCallInTypeSub1, [
          {
            oldKey: "_id",
            newKey: "value"
          },
          {
            oldKey: "description",
            newKey: "name"
          }
        ])
        this.setState({
          statusWaitingUpdate: false,
          callInType1List: newConvertDatas,
          callInType1ListRaw: nextProps.listsCallInTypeSub1, 
        }, () => {

        })
      }
      if(this.props.currentPage === 0 && this.state.tabsIndex != 0 ){
        this.setState({tabsIndex:0})
      }
  } 
  handleChangeState = name => event => {
    const val = event.target.value
    this.setState({
      [name]: val
    }, () => {
      if (name === "callInTypeCurrentID") {
        this.props.listsCallInTypeSub1Update(event.target.value)
      } 
    })
  } 
  handleChangeIndex = (key,value) => {  
    this.setState({ [key]:value });
  };  
  onStartCall = () =>{ 
      if(!this.state.rowCurrentData.tel){
        ErrorsCallback("ไม่สามารถโทรออกได้เนื่องจากไม่พบเบอร์ลูกค้า" )
        return
      } 
      if(this.state.rowCurrentData.tel.length != 10){
        ErrorsCallback("ไม่สามารถโทรออกได้เนื่องจากเบอร์โทรลูกค้าไม่ถูกต้อง" )
        return
      } 
    this.setState({isCalling:true},()=>{ 
      console.log("dial|88" + this.state.rowCurrentData.tel + "|Nissan_BP20"); 
      client.send("dial|88" + this.state.rowCurrentData.tel + "|Nissan_BP20");
    })
  }
  onStopCall = () =>{
    this.setState({isCalling:false,buttonSaveCall:true},()=>{
      console.log("Stop Calling : " + this.state.rowCurrentData.tel);
      client.send("hangup");
    })
  }
  onOpenQuestion = () =>{
    this.setState({isOpenQuestion:true},()=>{ 
    })
  }
  backToLists = () => {
    if(this.props.isSuccessCase || this.props.isSuccessQcCheck || this.props.isSuccessQcPass){
      this.props.callbacksetTabIndex(0)
      return
    }
    Alert.WarningCallback("คุณยังไม่ลงบันทึกการการโทร คุณต้องการกลับหน้ารายการหรือไม่?",(  )=>{
      this.setState({buttonSaveCall:false},()=>{
        this.props.callbacksetTabIndex(0)
      })
      
    },true,"ไปหน้ารายการ")
  }
  handleSubmitQCNotPassFixed = ()=>{
    QuestionCallback("รายการผ่านการแก้ไขแล้ว ใช่หรือไม่? ถ้าใช่ QC จะได้รับรายการนี้","yellow",()=>{ 
      const dataToSend = {
        lead_id: this.state._id, 
      } 
      APIPost( UrlServer.URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_FIXED_QC_NOTPASS,dataToSend,(datas)=>{ 
        this.setState({statusFixedQCNotPass:true},()=>{
          SuccessCallback(datas.message,null,()=>{ }) 
        })
      })
    })
  }
  handleSubmit = () => {
    if( this.state.callInTypeCurrentID === ""){
      WarningCallback("กรุณาเลือกสถานะหลัก")
    }else if(this.state.callInType1CurrentID === ""){
      WarningCallback("กรุณาเลือกสถานะย่อย")
    }else{ 
        this.handleSubmitRun()  
    }
  }
  handleSubmitRun = ()=>{
    const dataToSend = {
      lead_id: this.state._id,
      status_id: this.state.callInTypeCurrentID,
      substatus_id: this.state.callInType1CurrentID,
      remark: this.state.cerrentNote,
      called_count: this.state.rowCurrentData.called_count+1
    } 
    APIPost( UrlServer.URL_POST_POST_SAVECALLSTATUSTELESURVEY,dataToSend,(datas)=>{ 
        SuccessCallback(datas.message,null,()=>{
          this.setState ({
            callInTypeCurrentID: "",
            callInType1CurrentID: "",
            cerrentNote: "",
            buttonSaveCall:false
          },() =>{
            this.props.callbacksetTabIndex(0)
            Alert.Loading()
            this.props.listsCustomerSurveyUpdate(null,null,null,true,this.props.isSuccessCase,this.props.isSuccessQcCheck,this.props.isSuccessQcPass)
          }) 
        }) 
    })
  }
  handleSubmitCheckCase = (status) =>{
    if(this.state.cerrentQCNote == ""){
      WarningCallback("กรุณาบันทึกรายละเอียดการตรวจสอบ")
      return
    }
    QuestionCallback("คุณยืนยันการเลือก? " + ((status)?"ผ่าน":"ไม่ผ่าน"),(status)?"green":"red",()=>{
      const dataToSend = {
        lead_id: this.state._id,
        status: status, 
        note:this.state.cerrentQCNote
      } 
      APIPost( UrlServer.URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_STATUS,dataToSend,(datas)=>{ 
        SuccessCallback(datas.message,null,()=>{  
          Alert.Loading()
          this.props.callbacksetTabIndex(0)
          this.props.listsCustomerSurveyUpdate(null,null,null,true,this.props.isSuccessCase,this.props.isSuccessQcCheck,this.props.isSuccessQcPass) 
        }) 
      }) 
    })
  }
  handleSubmitCancelCase = () =>{

    QuestionCallback("คุณยืนยันการยกเลิกสถานะผ่านการตรวจสอบ ?","red",()=>{
      const dataToSend = {
        lead_id: this.state._id,
        note:this.state.cerrentQCNote
      } 
      APIPost( UrlServer.URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_QCCANCELSTATUS,dataToSend,(datas)=>{ 
        SuccessCallback(datas.message,null,()=>{ 
          this.props.callbacksetTabIndex(0)
          this.props.listsCustomerSurveyUpdate(null,null,null,true,this.props.isSuccessCase,this.props.isSuccessQcCheck,this.props.isSuccessQcPass) 
        }) 
      }) 
    })
  }
  handleSetState = (key,val) => {
    this.setState({[key]:val})
  }
  renderListStatus = (rawListDataTag)=>{
    return rawListDataTag.map((data,index)=>{
      var color_code = ""
      switch (data.status_id.code) {
        case 1:
          color_code = "txt-c-r"
          break;
        case 2:
          color_code = "txt-c-bu"
          break;
        case 3:
          color_code = "txt-c-dorg"
          break;
        case 4:
          color_code = "txt-c-g2"
          break;
        default:
          break;
      }
      return (
        <GridItem xs={12} key={"renderListStatus"+index} >
            <span className={"span-23062020-2026 "+ color_code}>{data.status_id.description+" :: "+data.substatus_id.description}</span> 
            <br/>
            <i className="span-23062020-2029"> 
            โดย {data.created_by_user.user_data_id.first_name+ " " + data.created_by_user.user_data_id.last_name} เมื่อ {ISOToDateYMDAndFullTime(data.created_date_iso)}
            </i><br/>
            <span>บันทึก : {data.remark}</span><br/>
            <hr className={"hr-24062020-1723"}/>
        </GridItem>
      )
    })
  }
  render() {
    const { classes } = this.props
    var lead_name = ""
    if( this.state.rowCurrentData && this.state.rowCurrentData.first_name ){
      lead_name += this.state.rowCurrentData.first_name
    }
    if( this.state.rowCurrentData && this.state.rowCurrentData.last_name ){
      lead_name += " " + this.state.rowCurrentData.last_name
    }
    var close_case_date = "ไม่พบในระบบ"
    var lead_data = null
    if( this.state.rowCurrentData && this.state.rowCurrentData.data ){
      lead_data = JSON.parse(this.state.rowCurrentData.data) 
      close_case_date = lead_data.Day_Delivery+"/"+lead_data.Month_Delivery+"/"+lead_data.Year_Delivery 
    }

    var check_mode = ""
    if(this.props.isSuccessQcCheck || this.props.isSuccessQcPass){
      check_mode = "/qc"
    }
    else if(userData.user_type_code == 5){
      check_mode = "/sup"
    }
    else{
      check_mode = "/admin"
    }

    if(this.props.currentPage === 0){ 
      return (<div></div>)
    }
    else
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ContactPhoneIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                    ข้อมูล
                </h4>
              </CardHeader>
              <CardBody> 
                  <GridContainer>
                    <GridItem xs={12}>  
                      <AppBar position="static" color="default">
                        <Tabs
                          value={this.state.tabsIndex}
                          onChange={(e,i)=>this.handleChangeIndex("tabsIndex",i)}
                          indicatorColor="primary"
                          textColor="primary"
                          variant="fullWidth" 
                          aria-label="scrollable force tabs example"
                        >
                          <Tab icon={<PhoneIcon />} label="โทร" />
                        {!this.props.isSuccessQcPass?
                          <Tab icon={<QuestionAnswerIcon />} label="ทำคำถาม" /> 
                        :<span/>}
                        </Tabs> 
                      </AppBar>
                    </GridItem> 
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <SwipeableViews
                        index={this.state.tabsIndex}
                        className="lead_detail"
                      >
                      <TabContainer > 
                        <GridContainer className="lead_detail_bg">
                         
                          <GridItem xs={6} sm={6} md={6} lg={6}>  
                          <Card className="card-sp">
                            <CardBody>
                          {!this.props.isSuccessCase && !this.props.isSuccessQcCheck && !this.props.isSuccessQcPass ?
                            <div>
                              {(!this.state.isCalling)?
                                <Button
                                  disabled = {!this.state.QAgantAllready}
                                  color = "success"
                                  round 
                                  onClick = { e=> this.onStartCall()}
                                  className={"W100"}
                                >
                                  <CallIcon className={classes.icons} />
                                  โทรออก {!this.state.QAgantAllready?" (ยังไม่เชื่อมต่อ QAgent)":" " + this.state.rowCurrentData.tel.substr(0,7)+"XXX"}
                                </Button>
                                :
                                <Button 
                                  disabled = {!this.state.QAgantAllready}
                                  color = "danger"
                                  round 
                                  onClick = { e=> this.onStopCall()}
                                  className={"W100"}
                                >
                                  <CallEndIcon className={classes.icons} />
                                  วางสาย {!this.state.QAgantAllready?" (ยังไม่เชื่อมต่อ QAgent)":" " + this.state.rowCurrentData.tel.substr(0,7)+"XXX"}
                                </Button>
                              }  
                              {(this.state.rowCurrentData.status_qc_comfirm == 3 && !this.state.statusFixedQCNotPass)? 
                                  <div>
                                    <hr/>
                                    <b>QC Comment</b><br/>
                                    {this.state.rowCurrentData.qc_note?this.state.rowCurrentData.qc_note:""}
                                    <Button
                                      fullWidth
                                      round
                                      color="warning"
                                      className={"m-tb-2"}
                                      onClick={(e)=>this.handleSubmitQCNotPassFixed()}
                                    >
                                      <CheckCircleOutlineIcon className={classes.icons} />
                                        ยืนยันการแก้ไข (QC ไม่ผ่าน)
                                    </Button>  
                                  </div>
                                  :""
                                }
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={4}>
                                  <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                    สถานะหลัก
                                  </FormLabel>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                  { 
                                    (this.state.callInTypeList.length > 0) ?
                                      <Select
                                        value={this.state.callInTypeCurrentID}
                                        listData={this.state.callInTypeList}
                                        onChange={this.handleChangeState("callInTypeCurrentID")}
                                        variant="outlined"
                                      />
                                    : ""
                                  }
                                </GridItem> 
                              </GridContainer> 
                            
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={4}>
                                  <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                    สถานะหลักย่อย
                                  </FormLabel>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                  { 
                                    (true || this.state.callInType1List.length > 0) ?
                                      <Select
                                        value={this.state.callInType1CurrentID}
                                        listData={this.state.callInType1List}
                                        onChange={this.handleChangeState("callInType1CurrentID")} 
                                        variant="outlined"
                                      />
                                    : ""
                                  }
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <TextField
                                    id="outlined-multiline-flexible"
                                    label="หมายเหตุ"
                                    multiline
                                    rowsMax={12}
                                    rows={4}    
                                    fullWidth
                                    value={this.state.cerrentNote}
                                    onChange={e=>this.handleSetState("cerrentNote",e.target.value)}
                                    variant="outlined"
                                  />
                                </GridItem> 
                              </GridContainer>   
                            </div>:""}
                              <GridContainer> 
                                <GridItem xs={(!this.props.isSuccessCase && !this.props.isSuccessQcCheck && !this.props.isSuccessQcPass)?6:12}>
                                  <Button
                                    fullWidth
                                    round
                                    color="tumblr"
                                    className={"m-tb-2"}
                                    onClick={(e)=>this.backToLists()}
                                  >
                                    <ArrowBackIcon className={classes.icons} />
                                      กลับหน้ารายการ
                                  </Button>
                                </GridItem>
                                {!this.props.isSuccessCase && !this.props.isSuccessQcCheck && !this.props.isSuccessQcPass ? 
                                <GridItem xs={6}>
                                  <Button
                                    disabled = {!this.state.buttonSaveCall}
                                    fullWidth
                                    round
                                    color="info"
                                    className={"m-tb-2"}
                                    onClick={this.handleSubmit}
                                  >
                                    <PlaylistAddIcon className={classes.icons} />
                                    บันทึกสถานะ และกลับสู่รายการ
                                  </Button>
                                </GridItem> 
                                :""}
                                
                                <GridItem xs={12}>
                                  <hr/>
                                  <Card className="card-sp">
                                    <CardBody>
                                      <div className="box_log_status">
                                        <GridContainer>
                                          {
                                            (this.state.rawListDataStatus.length > 0)?
                                              this.renderListStatus(this.state.rawListDataStatus)
                                            :""
                                          }
                                        </GridContainer>
                                      </div>
                                    </CardBody>  
                                  </Card>
                                </GridItem>
                                { this.props.isSuccessQcCheck || this.props.isSuccessQcPass  ?
                                   <GridItem xs={12}>
                                    <hr/>
                                    <GridContainer> 
                                      <GridItem xs={12}>
                                        <TextField
                                        disabled={(!this.props.isSuccessQcCheck && this.props.isSuccessQcPass)}
                                          id="outlined-multiline-flexible"
                                          label="หมายเหตุ การตรวจ"
                                          multiline
                                          rowsMax={12}
                                          rows={6}    
                                          fullWidth
                                          value={this.state.cerrentQCNote}
                                          onChange={e=>this.handleSetState("cerrentQCNote",e.target.value)}
                                          variant="outlined"
                                        />
                                      </GridItem> 
                                      {(this.props.isSuccessQcCheck && !this.props.isSuccessQcPass) ?
                                      <GridItem xs={6}>
                                        <Button
                                          fullWidth
                                          round
                                          color="success"
                                          className={"m-tb-2"}
                                          onClick={e=>this.handleSubmitCheckCase(true)}
                                        >
                                          <CheckCircleOutlineIcon className={classes.icons} />
                                          ผ่านการตรวจสอบ
                                        </Button>
                                      </GridItem>
                                      :""}
                                      {(this.props.isSuccessQcCheck && !this.props.isSuccessQcPass) ?
                                      <GridItem xs={6}>
                                        <Button
                                          fullWidth
                                          round
                                          color="danger"
                                          className={"m-tb-2"}
                                          onClick={e=>this.handleSubmitCheckCase(false)}
                                        >
                                          <HighlightOffIcon className={classes.icons} />
                                          ไม่ผ่านการตรวจสอบ
                                        </Button>
                                      </GridItem>
                                      :""}
                                      {(!this.props.isSuccessQcCheck && this.props.isSuccessQcPass) ?
                                      <GridItem xs={6}>
                                        <Button
                                          fullWidth
                                          round
                                          color="danger"
                                          className={"m-tb-2"}
                                          onClick={e=>this.handleSubmitCancelCase()}
                                        >
                                          <HighlightOffIcon className={classes.icons} />
                                          ยกเลิกสถานะผ่านการตรวจสอบ
                                        </Button>
                                      </GridItem>
                                      :""}
                                    </GridContainer>
                                   </GridItem>
                                  :""
                                }
                              </GridContainer>  
                              </CardBody>
                          </Card >  
                          </GridItem>
                          
                          <GridItem xs={12} sm={6} md={6} lg={6}>
                          {/* ข้อมูลลูกค้า */}
                          <Card className="card-sp">
                            <CardBody>
                          {
                            (this.state.rowCurrentData && this.state.rowCurrentData.tel)?
                              <TextField
                                id="standard-read-only-input"
                                label="เบอร์ติดต่อ"
                                defaultValue={this.state.rowCurrentData.tel}
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            :""
                          }
                          <br/><br/>
                          {
                            (lead_name != "")?
                            <TextField
                              id="standard-read-only-input"
                              label="ชื่อ-สกุล"
                              defaultValue={lead_name}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            :""
                          }           
                          <br/><br/> 
                          {
                            (lead_data && lead_data.Dealer_NameTH)?
                            <TextField
                              id="standard-read-only-input"
                              label="สาขา"
                              defaultValue={lead_data.Dealer_NameTH + " (" + ((lead_data.Branch_NameTH)?lead_data.Branch_NameTH:"") + ") "}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            :""
                          }  
                          <br/><br/> 
                          {
                            (this.state.rowCurrentData && this.state.rowCurrentData.send_sms_date)?
                            <TextField
                              id="standard-read-only-input"
                              label="วันส่ง SMS"
                              defaultValue={ISOToDateYMDAndFullTime(this.state.rowCurrentData.send_sms_date)}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            :""
                          }  
                          <br/><br/> 
                          {
                            (this.state.rowCurrentData && this.state.rowCurrentData.sms_expired_date)?
                            <TextField
                              id="standard-read-only-input"
                              label="วันที่คำถามหมดอายุ"
                              defaultValue={ISOToDateYMDAndFullTime(this.state.rowCurrentData.sms_expired_date)}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            :""
                          }  
                          <br/><br/> 
                          {
                            (this.state.rowCurrentData && this.state.rowCurrentData.lead_setting_id && this.state.rowCurrentData.lead_setting_id.description)?
                            <TextField
                              id="standard-read-only-input"
                              label="ชื่อตอนนำข้อมูลเข้า"
                              defaultValue={this.state.rowCurrentData.lead_setting_id.description}
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            :""
                          }   
                          </CardBody>
                          </Card>
                          </GridItem>
                        </GridContainer> 
                      </TabContainer>
                    { !this.props.isSuccessQcPass ?
                      <TabContainer>
                        <GridContainer className="lead_detail_bg">
                          {/* <GridItem xs={12} sm={12} md={12} lg={12}>
                            <div className="btn-tab-talk-script">  
                              <ExpansionPanel expanded={this.state.expansionPanelIsOpen1} onChange={e=>{this.setState({expansionPanelIsOpen1:!this.state.expansionPanelIsOpen1})}}>
                                <ExpansionPanelSummary
                                  className={classes.w100}
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Typography className={classes.heading}><b>สคริป "เปิด" ท้าย <small><i>(กดเพื่อ เปิด / ปิด)</i></small></b></Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails> 
                                    สวัสดีค่ะ/ครับ ดิฉัน/ผม .......{user_login_fullname}........เป็นพนักงานสัมภาษณ์จากบริษัทเอ็มโอแค็ป ซึ่งเป็นบริษัทวิจัย  โดยเป็นตัวแทนของบริษัท นิสสัน มอเตอร์ (ประเทศไทย)จำกัด เพื่อสอบถามและประเมินถึงความพึงพอใจของท่านต่อการนำรถเข้ารับบริการศูนย์ซ่อมสีและตัวถังในช่วงวันที่ …….{close_case_date}…….โดยข้อมูลนี้จะนำไปปรับปรุงและพัฒนาการบริการให้เป็นที่พึงพอใจสูงสุดของท่านต่อไป 
                                </ExpansionPanelDetails>
                              </ExpansionPanel>
                              <ExpansionPanel expanded={this.state.expansionPanelIsOpen2} onChange={e=>{this.setState({expansionPanelIsOpen2:!this.state.expansionPanelIsOpen2})}}>
                                <ExpansionPanelSummary
                                  className={classes.w100}
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Typography className={classes.heading}><b>สคริป "ปิด" ท้าย <small><i>(กดเพื่อ เปิด / ปิด)</i></small></b></Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails> 
                                    สุดท้ายนี้ ทางบริษัท เอ็มโอแค็ป ใคร่ขอขอบพระคุณ ท่านที่ได้สละเวลาในการให้สัมภาษณ์ในครั้งนี้  ทางเราจะนำข้อมูลไปใช้ประโยชน์ต่อการปรับปรุงการบริการให้มากที่สุดคะ
                                </ExpansionPanelDetails>
                              </ExpansionPanel>
                            </div> 
                          </GridItem>  */}
                          <GridItem xs={12} sm={12} md={12} lg={12}>  
                            <Iframe url={"/survey/pr/" + this.state.rowCurrentData._id + check_mode}
                              // position="absolute" 
                              id="i1"
                              className="addmin-question"
                              width="100%"
                              height="630px"
                              // styles={{height: "25px"}}
                            />    
                          </GridItem>
                        </GridContainer>
                      </TabContainer> 
                      :""}

                      </SwipeableViews>
                    </GridItem> 
                  </GridContainer>  
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer> 
      </div>
    )
  }
}
function mapStateToProps({ listsCallInType,listsCallInTypeSub1 }) {
  return {
    listsCallInType: listsCallInType,
    listsCallInTypeSub1: listsCallInTypeSub1
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsCallInTypeUpdate,
      listsCallInTypeSub1Update, 
      listsCustomerSurveyUpdate
     }
  )
)(ProjectCreateAndEditManagement)
